import { z } from "zod";

export const loginFormSchema = z.object({
	username : z
		.string()
		.min(1, { message : "Uživatelské jméno je povinné." }),
	password : z
		.string()
		.min(1, { message : "Heslo je povinné." }),
});